import { AreaCardProps } from './props';
import styles from './styles.module.scss';
import { Image } from '@starsoft/common/components';
import { useToggle } from '@starsoft/common/hooks';
import useTranslation from 'next-translate/useTranslation';

export default function AreaCard({ item }: AreaCardProps) {
  const { t } = useTranslation('common');
  const [isHovering, toggleHovering] = useToggle();

  return (
    <div
      className={styles.card}
      onMouseEnter={toggleHovering}
      onMouseLeave={toggleHovering}
    >
      <div className={styles.card__wrapper}>
        <div className={styles.card__icon__wrapper} data-theme="dark">
          <Image
            width={80}
            height={80}
            src={isHovering ? item.icon?.replace('svg', 'gif') : item.icon}
            className={styles.card__icon}
            bundle
            preload
            alt={`item-icon-${item.key}`}
          />
        </div>
        <h6 className={styles.card__title}>
          {t(`projects.${item.key}.title`)}
        </h6>
      </div>
      <p className={styles.card__description}>
        {t(`projects.${item.key}.description`)}
      </p>
    </div>
  );
}
